import React from 'react';
import { ControlledInputContainer } from 'public/components/ControlledInputContainer';

export default function Input({ input, handleInputChange, value, locked }) {
  const { name, label, required, placeholder, type } = input.fields;

  return (
    <ControlledInputContainer
      key={name}
      required={required}
      label={<label htmlFor={name}>{`${label}${required ? ' *' : ''}`}</label>}
      input={
        type === 'text-area' ? (
          <textarea
            name={name}
            id={name}
            onChange={(evt) =>
              handleInputChange({ ...input.fields, value: evt.target.value })
            }
            placeholder={placeholder}
            value={value || ''}
          />
        ) : (
          <input
            value={value || ''}
            id={name}
            name={name}
            type={type}
            placeholder={placeholder}
            readOnly={locked}
            data-locked={locked || undefined}
            onChange={(evt) =>
              handleInputChange({ ...input.fields, value: evt.target.value })
            }
          />
        )
      }
    />
  );
}
